import { render } from "./ButtonGroup.vue?vue&type=template&id=12c4f817"
import script from "./ButtonGroup.vue?vue&type=script&lang=js"
export * from "./ButtonGroup.vue?vue&type=script&lang=js"
script.render = render

export default script